import React, { useState } from "react";
import RegsugarcaneForOcsb from "../RegsugarcaneForOcsb/RegsugarcaneForOcsb";
import Map from "./Map";
function GIS() {
  const [showMap, setShowMap] = useState(false);

  return (
    <>
      <Map show={showMap} hidden={(a) => setShowMap(a)} />
      <RegsugarcaneForOcsb isMap={true} showMap={setShowMap} />
    </>
  );
}

export default GIS;
